module.exports = "a:hover{\r\n    text-decoration: underline;\r\n    background: black;\r\n}"